module.exports = __webpack_public_path__ + "static/media/D1.193df4ee.jpg";